<template>

    <div class="main">

        <!-- 資料讀取中 -->
        <div id="mask" class="hide">
            <div class="text">
                <i class="fas fa-spinner fa-pulse"></i> 資料讀取中
            </div>
        </div>
        <!-- 標題 -->
        <div class="main-title">
            <b-row align-h="between">
                <b-col cols="auto"><h2 class="px-3">{{ title }}</h2></b-col>
                <b-col cols="auto" align-self="center"><b-breadcrumb :items="items"></b-breadcrumb></b-col>
            </b-row>
        </div>
        <!-- 表單 -->
        <div class="w3-row" v-show="isPermissions">
            <!--按鈕 -->
            <div class="w3-col m2 search-field w3-right">
                <button class="w3-button w3-teal" @click="onInsert()"><i class="fa" :class="button.classAdd" aria-hidden="true"></i> {{ button.labelAdd }}</button>&nbsp;
                <button class="w3-button w3-light-green" @click="onPageFirst()"><i class="fa" :class="button.classSearch" aria-hidden="true"></i> {{ button.labelSearch }}</button>&nbsp;
            </div>
            <!--關鍵字 -->
            <div class="w3-col m4 search-field w3-right">
                <input class="w3-input w3-border" type="text" v-model="input.keyword.value"  :placeholder="input.keyword.placeholder" style="padding:4.5px;">
            </div>
        </div>        
        <!-- 總筆數 -->
        <div class="page-row-info" v-show="isPermissions">
            共有 {{ table.rowCount }} 筆結果。
        </div>
        <!-- 表格 -->
        <div class="table-scroll" v-show="isPermissions">
            <table>
                <thead>
                    <tr>
                        <th nowrap="nowrap" class="table-field" >標題</th>
                        <th nowrap="nowrap" class="table-field" >簡述</th>
                        <th nowrap="nowrap" class="table-field" >來源出處</th>
                        <th nowrap="nowrap" class="table-field" style="width: 50px;">啟用狀態</th>
                        <th nowrap="nowrap" class="table-field" style="width: 125px;">上架時間</th>
                        <th nowrap="nowrap" class="table-field" style="width: 125px;">下架時間</th>
                        <th nowrap="nowrap" class="table-field" style="width: 125px;">編輯</th>
                    </tr>
                </thead>
                <tbody v-show="table.menu.length > 0 ">
                    <template v-for="(value, key) in table.menu">
                        <tr :key="'item'+key">
                            <!-- 標題 -->
                            <td nowrap="nowrap" class="table-value">
                                {{ value.Title && value.Title.length > 15 ? value.Title.substring(0, 15) + '...' : value.Title }}
                            </td>
                            <!-- 簡述 -->
                            <td nowrap="nowrap" class="table-value">
                                {{ value.Descript && value.Descript.length > 35 ? value.Descript.substring(0, 35) + '...' : value.Descript }}
                            </td>
                            <!-- 來源出處 -->
                            <td nowrap="nowrap" class="table-value"> 
                                <!-- 有來源文字 -->
                                <template v-if="value.Source && value.Source.trim() !== ''">
                                    <a v-if="value.SourceUrl"
                                    :href="value.SourceUrl"
                                    target="_blank">
                                    {{ value.Source }}
                                    </a>
                                    <span v-else>
                                    {{ value.Source }}
                                    </span>
                                </template>

                                <!-- 無來源文字 -->
                                <span v-else>無</span>
                            </td>
                            <!-- 啟用狀態 -->
                            <td nowrap="nowrap" class="table-value">
                                <span
                                    class="status-light"
                                    :class="value.Enable == 'True' ? 'on' : 'off'">
                                </span>
                                <!--
                                {{ value.Enable == "True" ? "啟用" : "停用" }}
                                 -->
                            </td>
                            <!-- 上架時間 -->
                            <td nowrap="nowrap" class="table-value">{{ value.OnTime.replace("T", " ") }}</td>
                            <!-- 下架時間 -->
                            <td nowrap="nowrap" class="table-value">{{ value.OffTime.replace("T", " ") }}</td>
                            <!-- 編輯 -->
                            <td nowrap="nowrap" class="table-value">
                                <button class="w3-button w3-indigo" @click="onModify(value, key)"><i class="fa" :class="button.classEdit" aria-hidden="true"></i> {{ button.labelEdit }}</button>&nbsp;
                                <button class="w3-button w3-red" @click="onDelete(value, key)"><i class="fa" :class="button.classDel" aria-hidden="true"></i> {{ button.labelDel }}</button>
                            </td>
                        </tr>
                    </template>
                </tbody>
                <tbody v-show="table.menu.length == 0 ">
                    <tr>
                        <td nowrap="nowrap" class="table-value" colspan="11">{{ message.noeExistPlant }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- 分頁 -->
        <div class="text-center" v-show="isPermissions">
            <nav aria-label="Pagination">
                <span>
                    <a v-show="table.pageAt > 1" class="w3-bar-item w3-button" @click="onPagePrevious()">&laquo;</a>
                    <template v-for="n in table.pageCount">
                        <a v-if="n>table.pageAt-5 && n<table.pageAt+5" :key="n" class="w3-bar-item w3-button" :class="{ 'w3-green': table.pageAt==n }" @click="onPageNum(n)">{{n}}</a>
                    </template>
                    <a v-show="table.pageAt < table.pageCount"  class="w3-bar-item w3-button" @click="onPageNext()">&raquo;</a>
                </span>
            </nav>
        </div>

        <!-- 其他 -->
        <div class="main-content">
            <!-- 彈出視窗(新增、修改) -->
            <div id="dialog_info" class="w3-modal" :style="modal.info.modalStyleProcess">
                <div class="body w3-modal-content w3-card-4 w3-animate-zoom">
        
                    <!-- 表頭 (操作動作、關閉視窗按鈕) -->
                    <header class="w3-container" :class="modal.info.moduleProcessSubmit=='add'?'w3-teal':'w3-indigo'"> 
                        <span @click="modal.info.modalStyleProcess.display='none'" class="w3-button w3-display-topright">&times;</span>
                        <h5><i class="fa" :class="modal.info.iconProcessSubmit" aria-hidden="true"></i> {{ modal.info.titleProcessSubmit }}</h5>
                    </header>

                    <!-- 標題 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.info.labelTitle }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="text" style="max-width: 300px;width: 100%;" v-model="modal.info.valueTitle" :disabled="modal.info.disabledTitle" :placeholder="modal.info.placeholderTitle">
                        </div>
                    </div>
                    
                    <!-- 簡述 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.info.labelDescript }}
                        </div>
                        <div class="value w3-col w3-container">
                            <textarea
                                style="width: 100%;"
                                v-model="modal.info.valueDescript"
                                :disabled="modal.info.disabledDescript"
                                :placeholder="modal.info.placeholderDescript"
                                rows="5">
                            </textarea>
                        </div>
                    </div>

                    <!-- 照片 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.info.labelPhoto }}
                        </div>
                        <div class="value w3-col w3-container">
                            <button v-if="modal.info.menuPhoto.length == 0" class="w3-button w3-brown" @click="onUpload()"><i class="fa" :class="button.classUpload" aria-hidden="true"></i> {{ button.labelUpload }}</button>
                            <template v-for="(value, key) in modal.info.menuPhoto">
                                <div :key="'item'+key" style="padding: 10px;">
                                    <button class="w3-button w3-red" @click="onUploadDelete(value)"><i class="fa" :class="button.classDel" aria-hidden="true"></i> {{ button.labelDel }}</button><br /> 
                                    <img style="width: 260px;" :src="value.PATH.replace(/^.*\\upload\\/, '/upload/').replace(/\\/g, '/')" />  
                                </div>
                            </template>
                        </div>
                    </div>

                    <!-- 啟用狀態 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.info.labelEnable }}
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.info.valueEnable" :disabled="modal.info.disabledEnable" style="width: 80px">
                                <option v-for="(value, key) in modal.info.menuEnable" :value="value.Value" :key="'valueEnable' + key">
                                    {{ value.Title }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- 上架時間 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.info.labelOnTime }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="datetime-local" v-model="modal.info.valueOnTime" :disabled="modal.info.disabledOnTime" :placeholder="modal.info.placeholderOnTime">
                        </div>
                    </div>

                    <!-- 下架時間 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.info.labelOffTime }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="datetime-local" v-model="modal.info.valueOffTime" :disabled="modal.info.disabledOffTime" :placeholder="modal.info.placeholderOffTime">
                        </div>
                    </div>    

                    <!-- 來源出處 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.info.labelSource }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="text" style="max-width: 300px;width: 100%;" v-model="modal.info.valueSource" :disabled="modal.info.disabledSource" :placeholder="modal.info.placeholderSource">
                        </div>
                    </div>

                    <!-- 來源出處(網址) -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.info.labelSourceUrl }}
                        </div>
                        <div class="value w3-col w3-container">
                            <textarea
                                style="width: 100%;"
                                v-model="modal.info.valueSourceUrl"
                                :disabled="modal.info.disabledSourceUrl"
                                :placeholder="modal.info.placeholderSourceUrl"
                                rows="5">
                            </textarea>
                        </div>
                    </div>

                    <!-- 表尾 (操作動作、提交按鈕) -->
                    <p> 
                        <button class="w3-button w3-block" :class="modal.info.moduleProcessSubmit=='add'?'w3-teal':'w3-indigo'"  @click="onSava"><i class="fa" :class="modal.info.iconProcessSubmit" aria-hidden="true"></i> {{ modal.info.btnProcessSubmit }}</button>
                    </p>
                    
                </div>
            </div>
            <!-- 彈出視窗(上傳) -->
            <div id="dialog_info" class="w3-modal" :style="modal.upload.modalStyleProcess">
                <div class="body w3-modal-content w3-card-4 w3-animate-zoom">
                    <!-- 表頭 (操作動作、關閉視窗按鈕) -->
                     
                    <header class="w3-container" :class="'w3-brown'"> 
                        <span @click="modal.upload.modalStyleProcess.display='none'" class="w3-button w3-display-topright">&times;</span>
                        <h5><i class="fa" :class="modal.upload.iconProcessSubmit" aria-hidden="true"></i> {{ modal.upload.titleProcessSubmit }}</h5>
                    </header>

                    <div class="grid-x grid-padding-x">
                        <div class="small-12 cell" style="padding:30px;">
                            <input type="file" id="valueProcessEXTERNAL_PHOTO" accept=".jpg,.jpeg,.png,.gif"> 
                            <span class="required">(圖片檔限500KB內)</span> 
                        </div>
                    </div>

                    <!-- 表尾 (操作動作、提交按鈕) -->
                    <p> 
                        <button class="w3-button w3-block" :class="'w3-brown'"  @click="onUploadSava"><i class="fa fa-upload" aria-hidden="true"></i> {{ modal.upload.btnProcessSubmit }}</button>
                    </p>

                </div>
            </div>
        </div>

        <!-- 其他 -->
        <div class="no-permissions" v-show="!isPermissions">
            您目前沒有權限瀏覽此頁面，請使用管理者權限的帳號登入。
        </div>

    </div>
    
</template>
<script>

    export default {
        data() {
            return {

                website_prefix:'http://localhost:59489/',

                GUID:"",

                apiLatestNewsSelect: (data) => this.userRequest.post("/API/Default/LatestNewsSelect", data),
                apiLatestNewsInsert: (data) => this.userRequest.post("/API/Default/LatestNewsInsert", data),
                apiLatestNewsUpdate: (data) => this.userRequest.post("/API/Default/LatestNewsUpdate", data),
                apiLatestNewsDelete: (data) => this.userRequest.post("/API/Default/LatestNewsDelete", data),
      
                apiUploadSelect: (data) => this.userRequest.post("/API/UploadFile/UPLOAD_FILESelect", data),
                apiDeleteFileAction: (data) => this.userRequest.post("/API/UploadFile/DeleteFileAction", data),

                //標題
                title:"最新消息(後台)",
                //導覽列
                items: [
                    {
                        text: '首頁',
                        href: '#/'
                    },
                    {
                        text: '最新消息(後台)',
                        active: true
                    }
                ],

                //是否是在開發模式
                isDevelop:false,

                //是否有權限操作
                isPermissions:false,

                //表單物件
                input:{
                    //關鍵字
                    keyword:{
                        text:"關鍵字",
                        value:"",
                        placeholder:"請輸入關鍵字(標題、簡述、來源出處)",
                        list:[],
                    },
                },

                //表格
                table:{

                    //表單
                    menu:[],
                    //總頁數
                    pageCount:0,
                    //總筆數
                    rowCount:0,
                    //清單排序
                    orderBy:"ID Desc ",
                    // 分頁所在
                    pageAt:1,
                    // 分頁筆數
                    pageSize:10,
                },

                //相關按鈕
                button:{

                    labelSearch: "搜尋",
                    classSearch:"fa-search",

                    labelAdd: "新增",
                    classAdd:"fa-plus",

                    labelEdit: "修改",
                    classEdit:"fa-paint-brush",

                    labelDel: "刪除",
                    classDel:"fa-trash",

                    labelUpload: "上傳",
                    classUpload:"fa-upload",
                },
                //訊息
                message:{
                    noeExistPlant:"沒有任何最新消息，請確認搜尋條件是否正確?",  
                    confirmDelete:"您確認要刪除這筆資料?",    
                    doneUpdate:"修改成功。",      
                    doneDelete:"刪除成功。",   
                    errorUpdate:"修改失敗。",      
                    errorDelete:"刪除失敗。", 
                },
                //彈出視窗
                modal:{

                    //最新消息(新增、修改)
                    info:{

                        // 用於 決定彈出視窗呈現或隱藏
                        modalStyleProcess: { display: "none" },
                        
                        // 用於 彈出視窗的動作(add-新增、edit-修改、browse-瀏覽)
                        moduleProcessSubmit: "add",
                        //moduleProcessSubmit: "edit",
                        //moduleProcessSubmit: "browse",
                        // 用於 彈出視窗的標題
                        titleProcessSubmit: "新增",
                        // 用於 彈出視窗的圖示(fa-plus 新增、fa-paint-brush 修改)
                        iconProcessSubmit: "",
                        // 用於 彈出視窗的按鈕名稱
                        btnProcessSubmit: "新增",
                        // 用於 彈出視窗要修改清單上的哪個項目(若是新增他會是-1，若是修改它會是清單上項目的索引值)
                        indexProcessSubmit: -1,

                        labelID: "識別碼 : ",
                        valueID: "",
                        disabledID: false,
                        placeholderID: "",
                        menuID:[],

                        labelTitle: "標題 : ",
                        valueTitle: "",
                        disabledTitle: false,
                        placeholderTitle: "",
                        menuTitle:[],

                        labelDescript: "簡述 : ",
                        valueDescript: "",
                        disabledDescript: false,
                        placeholderDescript: "",
                        menuDescript:[],

                        labelPhoto: "照片 : ",
                        valuePhoto: "",
                        disabledPhoto: false,
                        placeholderPhoto: "",
                        menuPhoto:[],


                        labelSource: "來源出處 : ",
                        valueSource: "",
                        disabledSource: false,
                        placeholderSource: "",
                        menuSource:[],

                        labelSourceUrl: "來源出處(網址) : ",
                        valueSourceUrl: "",
                        disabledSourceUrl: false,
                        placeholderSourceUrl: "",
                        menuSourceUrl:[],

                        labelEnable: "啟用狀態 : ",
                        valueEnable: "",
                        disabledEnable: false,
                        placeholderEnable: "",
                        menuEnable:[
                            { Title:"啟用", Value:"True" },
                            { Title:"停用", Value:"False" }
                        ],

                        labelOnTime: "上架時間 : ",
                        valueOnTime: "",
                        disabledOnTime: false,
                        placeholderOnTime: "",
                        menuOnTime:[],
   
                        labelOffTime: "下架時間 : ",
                        valueOffTime: "",
                        disabledOffTime: false,
                        placeholderOffTime: "",
                        menuOffTime:[],
                    },
                    //上傳
                    upload:{

                        // 用於 決定彈出視窗呈現或隱藏
                        modalStyleProcess: { display: "none" },
                        // 用於 彈出視窗的標題
                        titleProcessSubmit: "上傳",
                        // 用於 彈出視窗的圖示(fa-plus 新增、fa-paint-brush 修改)
                        iconProcessSubmit: "",
                        // 用於 彈出視窗的按鈕名稱
                        btnProcessSubmit: "上傳",

                        labelID: "識別碼 : ",
                        valueID: "",
                        disabledID: false,
                        placeholderID: "",
                        menuID:[],

                        labelTitle: "標題 : ",
                        valueTitle: "",
                        disabledTitle: false,
                        placeholderTitle: "",
                        menuTitle:[],
                    },

                },
            }
        },
        watch: {

            //彈出視窗的狀態
            "modal.info.modalStyleProcess.display":function(val){

                if(val.toLowerCase() != "block")
                {
                    //關閉
                    this.onClearModalProcess();
                }
            },

        },
        mounted(){

            window.vue = this;  //在created方法中，將變數全局化，主控台可用 window.vue._data 調閱或呼叫(若不用可以直接遮罩)
                                //例如:window.vue._data.map.getCesiumScene().setEnabled(false);
                   
            //window.vue.isPermissions = false;
            //測試專用
            window.vue.isPermissions = true;

            this.GUID = window.RandomTool.GUID();

            this.apiGetAccountInfo({

                TokenID:sessionStorage.getItem("TokenID")
            })
            .then((res) => {

                var data = JSON.parse(res.data);
                if(data.EXIST && data.AG_ID == "0"){

                    window.vue.isPermissions = true;
                    //取得種植登記紀錄
                    //this.onSelect();
                }

                this.onSelect();
            })
            .catch((error) => {
                alert("發生錯誤!" + error);
            });

        },
        created() {
               
        },
        destroyed() {

        },
        methods: {

            //啟用遮罩
            enableDefaultLoad:function()
            {
                this.enableMask();
                this.default_load = true;
            },
            //取消遮罩
            disableDefaultLoad:function()
            { 
                //暫時先設定延遲，否則watch會重複觸發
                const _this = this;
                window.ThreadTool.Delay(function(){
                
                    _this.disableMask();
                    _this.default_load = false;

                },this.delay_ms_api);
            },   

            //上傳
            onUpload:function(){ 

                this.modal.upload.modalStyleProcess.display = "block";
            },

            //上傳(查詢)
            onUploadSelect:function(){ 

                if(this.modal.info.moduleProcessSubmit == "add")
                {   
                    this.apiUploadSelect({

                        REFER_TO:"LATEST_NEWS",
                        GUID:this.GUID,
                        REFER_TO_TYPE:"PHOTO"
                    })
                    .then((res) => {

                        var data = JSON.parse(res.data);
                        window.vue.modal.info.menuPhoto = data;
                        console.log(window.vue.modal.info.menuPhoto);
                    })
                    .catch((error) => {
                        alert("發生錯誤!" + error);
                    });

                }else{

                    this.apiUploadSelect({

                        REFER_TO:"LATEST_NEWS",
                        REFER_TO_SN:this.modal.info.valueID,
                        REFER_TO_TYPE:"PHOTO"
                    })
                    .then((res) => {

                        var data = JSON.parse(res.data);
                        window.vue.modal.info.menuPhoto = data;
                        console.log(window.vue.modal.info.menuPhoto);
                    })
                    .catch((error) => {
                        alert("發生錯誤!" + error);
                    });

                }

            },

            //上傳(刪除)
            onUploadDelete:function(value){ 

                var yes = confirm(this.message.confirmDelete);

                if (yes) 
                {
                    //你按了確定按鈕
                    this.apiDeleteFileAction({

                        SN:value.SN,
                        ID:value.ID
                    })
                    .then((res) => {

                        var data = JSON.parse(res.data);
                        console.log(data);
                        window.vue.onUploadSelect();
                    })
                    .catch((error) => {
                        alert("發生錯誤!" + error);
                    });

                } else {
                    //你按了取消按鈕 
                }
            },

            onUploadSava:function(){ 

                if (window.$("#valueProcessEXTERNAL_PHOTO").val() == "") { alert("請先選擇檔案上傳");  return; }

                var file_format = ["jpg","jpeg","png","gif"];

                if(file_format.indexOf(window.$("#valueProcessEXTERNAL_PHOTO").val().split('.').pop().toLowerCase()) == -1){ alert("檔案格式有誤，請用圖片檔案上傳(jpg,jpeg,png,gif)");  return;}

                const _this = this;
    
                window.$(function () {
              
                    var fileUpload = window.$("#valueProcessEXTERNAL_PHOTO").get(0);
                    var files = fileUpload.files;
                    var data = new FormData();

                    var isAbove500k = false;
                    var size500k = 550 * 1024;

                    for(var i=0 ; i<files.length ; i++)
                    {
                        if(files[i].size > size500k)
                        {
                            isAbove500k = true;
                        }
                    }

                    if(isAbove500k)
                    {
                        alert("您所上傳的檔案，超過500K，無法上傳附件");
                        return false;
                    }

                    data.append("GUID", _this.GUID);
                    data.append("MODEL", _this.modal.info.moduleProcessSubmit);

                    data.append("REFER_TO", "LATEST_NEWS");
                    data.append("REFER_TO_TYPE", "PHOTO");
                    data.append("REFER_TO_SN", _this.modal.info.valueID);
                    data.append("TITLE", "相片");
                    data.append("MEMO", "");

                    //改成一個檔案上傳
                    //data.append(files[0].name, files[0]);

                    //改成多個檔案上傳
                    for(var i2=0 ; i2<files.length ; i2++)
                    {
                        data.append(files[i2].name, files[i2]);
                    }

                    window.$.ajax({
                        //請求方式
                        type: "POST",
                        //請求的媒體類型
                        //contentType: "application/json;charset=UTF-8",
                        contentType: false,
                        processData: false,
                        //success後端回傳資料自動轉Json格式
                        dataType: "json",
                        //請求地址
                        //url: this.website_prefix + "Api/UploadFile/UploadFileAction",
                        url: "api/Api/UploadFile/UploadFileAction",
                        //數據，json字符串
                        data: data,
                        //data: $("#postForm").serialize(),
                        //請求成功
                        success: function (result) {

                            result = JSON.parse(result);
                            var state = result.state;
                            //var message = result.message;

                            if(state)
                            {
                                window.$("#valueProcessEXTERNAL_PHOTO").val("");
                                _this.onUploadSelect();
                                _this.modal.upload.modalStyleProcess.display = 'none';
                            }

                        },
                        //請求失敗，包含具體的錯誤信息
                        error: function (e) {
                            console.log(e);
                        }
                    });
                });
            },

            // 查詢
            onSelect:function(){

                this.apiLatestNewsSelect({

                    Keyword:this.input.keyword.value,
                    OrderBy:this.table.orderBy,
                    PageAt:this.table.pageAt,
                    PageSize:this.table.pageSize,
                })
                .then((res) => {

                    var data = JSON.parse(res.data);
                    if(data.menu == null){ data.menu = []; }
                    this.table.menu = data.menu;
                    this.table.pageAt = data.PageAt;
                    this.table.pageCount = data.PageCount;
                    this.table.rowCount = data.RowCount;
                    console.log(data);
                })
                .catch((error) => {
                    alert("發生錯誤!" + error);
                });
            },

            // 新增
            onInsert:function(){

                //因為新增有切換功能，所以一起設定
                this.onClearModalProcess();
                this.onSetModalProcessModule("add");
                this.modal.info.indexProcessSubmit = -1;
                this.modal.info.modalStyleProcess.display = "block";

                this.onUploadSelect();
            },
            // 修改
            onModify:function(value,key){

                console.log(value);
                this.onClearModalProcess();
                this.onSetModalProcessModule("edit");
                this.modal.info.indexProcessSubmit = key;
                this.modal.info.modalStyleProcess.display = "block";

                //識別碼
                this.modal.info.valueID = value.ID;
                //標題
                this.modal.info.valueTitle = value.Title;
                //簡述
                this.modal.info.valueDescript = value.Descript;
                //啟用狀態
                this.modal.info.valueEnable = value.Enable;
                //上架時間
                this.modal.info.valueOnTime = value.OnTime;
                //下架時間
                this.modal.info.valueOffTime = value.OffTime;
                //來源出處
                this.modal.info.valueSource = value.Source;
                //來源出處(網址)
                this.modal.info.valueSourceUrl = value.SourceUrl;

                this.onUploadSelect();
            },
            // 儲存(已登記)(新增、修改、瀏覽 點選視窗下面的按鈕)
            onSava: function () {
 
                //新增或修改 都要驗證欄位
                if(this.modal.info.moduleProcessSubmit == "add" || this.modal.info.moduleProcessSubmit == "edit")
                {
                    if(this.modal.info.valueTitle == ""){  alert(this.getPleaseEnterField("標題"));  return false; }
                    if(this.modal.info.valueDescript == ""){  alert(this.getPleaseEnterField("簡述"));  return false; }
                    if(this.modal.info.valueEnable == ""){  alert(this.getPleaseChooseField("啟用狀況"));  return false; }
                    if(this.modal.info.valueOnTime == ""){  alert(this.getPleaseChooseField("上架時間"));  return false; }
                    if(this.modal.info.valueOffTime == ""){  alert(this.getPleaseChooseField("下架時間"));  return false; }

                    if(this.modal.info.valueSource == ""){  alert(this.getPleaseEnterField("來源出處"));  return false; }
                    if(this.modal.info.valueSourceUrl == ""){  alert(this.getPleaseEnterField("來源出處(網址)"));  return false; }

                    if(this.modal.info.valueSource == null){ this.modal.info.valueSource == ""; }
                    if(this.modal.info.valueSourceUrl == null){ this.modal.info.valueSourceUrl == ""; }   
                }

                if(this.modal.info.moduleProcessSubmit == "add")
                {            
                    this.apiLatestNewsInsert({
                        GUID:this.GUID,
                        ID:this.modal.info.valueID,
                        Title:this.modal.info.valueTitle,
                        Descript:this.modal.info.valueDescript,
                        Enable:this.modal.info.valueEnable,
                        OnTime:this.modal.info.valueOnTime.replace("T", " "),
                        OffTime:this.modal.info.valueOffTime.replace("T", " "),
                        
                        Source:this.modal.info.valueSource,
                        SourceUrl:this.modal.info.valueSourceUrl
                    })
                    .then((res) => {

                        var data = JSON.parse(res.data);
                        if(data.state)
                        {
                            alert(data.message);
                            window.vue.onSelect();
                        }
                        this.modal.info.modalStyleProcess.display = 'none';
                    })
                    .catch((error) => {
                        alert("發生錯誤!" + error);
                    });

                    
                }
                else if(this.modal.info.moduleProcessSubmit == "edit")
                {
                    this.apiLatestNewsUpdate({

                        ID:this.modal.info.valueID,
                        Title:this.modal.info.valueTitle,
                        Descript:this.modal.info.valueDescript,
                        Enable:this.modal.info.valueEnable,
                        OnTime:this.modal.info.valueOnTime.replace("T", " "),
                        OffTime:this.modal.info.valueOffTime.replace("T", " "),
                        
                        Source:this.modal.info.valueSource,
                        SourceUrl:this.modal.info.valueSourceUrl
                    })
                    .then((res) => {

                        var data = JSON.parse(res.data);
                        if(data.state)
                        {
                            alert(data.message);
                            window.vue.onSelect();
                        }
                        this.modal.info.modalStyleProcess.display = 'none';
                    })
                    .catch((error) => {
                        alert("發生錯誤!" + error);
                    });
                    this.modal.info.modalStyleProcess.display = 'none';
                }

            },
            // 刪除
            onDelete: function (value) {

                var yes = confirm(this.message.confirmDelete);

                if (yes) 
                {
                    //你按了確定按鈕
                    this.apiLatestNewsDelete({

                        ID:value.ID,
                    })
                    .then((res) => {

                        var data = JSON.parse(res.data);
                        if(data.state)
                        {
                            alert(data.message);
                            window.vue.onSelect();
                        }
                        this.modal.info.modalStyleProcess.display = 'none';
                    })
                    .catch((error) => {
                        alert("發生錯誤!" + error);
                    });
                    this.modal.info.modalStyleProcess.display = 'none';
                } else {
                    //你按了取消按鈕 
                }
            },

            // 設定彈出視窗的作業模式
            onSetModalProcessModule: function(module){

                if(module == "add"){
        
                    this.modal.info.titleProcessSubmit = "新增";
                    this.modal.info.btnProcessSubmit = "新增";
                    this.modal.info.iconProcessSubmit = "fa-plus";
                    this.modal.info.moduleProcessSubmit = module;
                    
                }else if(module == "edit"){
        
                    this.modal.info.titleProcessSubmit = "修改";
                    this.modal.info.btnProcessSubmit = "修改";
                    this.modal.info.iconProcessSubmit = "fa-paint-brush";
                    this.modal.info.moduleProcessSubmit = module; 
                }
            },

            // 清空彈出視窗的所有欄位
            onClearModalProcess:function(){

                //識別碼
                this.modal.info.valueID = "";
                //標題
                this.modal.info.valueTitle = "";
                //簡述
                this.modal.info.valueDescript = "";
                //照片
                this.modal.info.valuePhoto = "";
                this.modal.info.menuPhoto = [];
                //來源出處
                this.modal.info.valueSource = "";
                //來源出處(網址)
                this.modal.info.valueSourceUrl = "";
                //啟用狀態
                this.modal.info.valueEnable = "False";
                //上架時間
                this.modal.info.valueOnTime = "";
                //下架時間
                this.modal.info.valueOffTime = "";
            },

            //第一頁
            onPageFirst:function(){

                this.table.pageAt = 1;
                this.onSelect();
            },
            //上一頁
            onPagePrevious:function(){

                this.table.pageAt = this.table.pageAt - 1;
                this.onSelect();
            },
            //下一頁
            onPageNext:function(){

                this.table.pageAt = this.table.pageAt + 1;
                this.onSelect();
            },
            //指定第n頁
            onPageNum:function(n){

                if(this.table.pageAt != n)
                {
                    this.table.pageAt = n;
                    this.onSelect();
                }
            },

            //取得使用者Xxx欄位未輸入訊息
            getPleaseEnterField: function(ParamName) { return "請輸入【" + ParamName + "】！"; },
            //取得使用者Xxx欄位未選擇訊息
            getPleaseChooseField: function(ParamName) { return "請選擇【" + ParamName + "】！"; },
            //取得使用者Xxx欄位為空訊息
            getErrorMessageParamEmpty: function(ParamName) { return "操作失敗，【" + ParamName + "】不可為空！"; },
        
        },
    }

</script>
<style scoped>

/** 搜尋欄位(年度、鄉鎮、作物、期作、關鍵字) */
.search-field
{
    padding-left: 10px;
}
/** 搜尋欄位(按鈕) */
.search-field button
{
    font-size: 13px;
}

/** 總筆數 */
.page-row-info
{
    text-align: right;
    padding: 5px;
    font-size: 14px;
    padding-right: 25px; 
}

/** 表格 */
table {
    border-collapse: collapse;
    width: 100%;
    margin-bottom: 1rem;
    border-radius: 4px;
    font-size: 12px;
    text-indent: 0;
    border-color: inherit;
}
/** 表格(表頭、表身) */
thead th, thead,tbody th, tbody, td, tfoot th, tfoot td {
    padding: 0.5rem 0.625rem 0.625rem;
    font-weight: bold;
    text-align: left;
}
/** 表格(表頭) */
thead {
    border: 1px solid #f1f1f1;
    background-color: #f1f1f1;
}
/** 表格(表身) */
tbody tr {
    border-bottom: 0;
    background-color: #ffffff;
}
tbody tr:nth-child(even) {
    background-color: #f1f1f1;
}

/** 表格-卷軸 */
.table-scroll {
    overflow-x: auto;
}

/** 表格-欄位 */
.table-field {
    text-align: center !important;
}

/** 表格-數值 */
.table-value {
    text-align: center !important;
    color:#666666;
}

/** 新增、修改彈出視窗 內容 */
#dialog_info .body
{
    max-width: 560px;
}

/** 新增、修改彈出視窗 欄位 */
#dialog_info .field
{
    text-align:right;
    font-weight: 500;
    margin-bottom: 0px;
    margin-top: 8px;
    padding-right: 3px;
    width:30%;
}

/** 新增、修改彈出視窗 數值 */
#dialog_info .value
{
    width:65%;
    padding: 5px;
}

/** 必填欄位 */
.required
{
    color: #FF0000;
}

/** 沒有權限 */
.no-permissions
{
    text-align: center;

} 



.status-light {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
}

/* 啟用：綠燈 */
.status-light.on {
  background-color: #2ecc71;
}

/* 停用：紅燈 */
.status-light.off {
  background-color: #e74c3c;
}

.w3-modal button {

    font-size: 12px;
}

</style>